import { createApp } from "vue";
// import Antd, { message } from "ant-design-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import "ant-design-vue/dist/antd.css";
import utils from "@/utils";
import enums from "@/libraries/enums";
import consts from "@/libraries/consts";
// import "vant/lib/index.css";
import '@/assets/iconfont/iconfont.css'
import VConsole from "vconsole";
// 以下应用监控代码暂不开启，在环境上会报错！！！
// import ArmsRum from '@arms/rum-browser';
// // 初始化应用监控
// ArmsRum.init({
//   pid: 'b857mavr87@f0e0baf55ed20ce63b7d3',
//   endpoint: 'https://proj-xtrace-9bcea6d5797cbd7ea9ddd5a1f7457c7-cn-zhangjiakou.cn-zhangjiakou.log.aliyuncs.com/rum/web/v2?workspace=vmosphone-web&service_id=b857mavr87@f0e0baf55ed20ce63b7d3',
//   // 设置环境信息，参考值：'prod' | 'gray' | 'pre' | 'daily' | 'local'
//   env: 'prod',
//   // 设置路由模式， 参考值：'history' | 'hash'
//   spaMode: 'history',
//   collectors: {
//     // 页面性能指标监听开关，默认开启
//     perf: true,
//     // WebVitals指标监听开关，默认开启
//     webVitals: true,
//     // Ajax监听开关，默认开启
//     api: true,
//     // 静态资源开关，默认开启
//     staticResource: true,
//     // JS错误监听开关，默认开启
//     jsError: true,
//     // 控制台错误监听开关，默认开启
//     consoleError: true,
//     // 用户行为监听开关，默认开启
//     action: true,
//   },
//   // 链路追踪配置开关，默认关闭
//   tracing: true,
// });

// 如果不是生产地址，加载console
if (process.env.VUE_APP_NODE_ENV !== "prod") {
  new VConsole();
}

var _hmt = _hmt || [];
window._hmt = _hmt; // 修改为window 全局变量
(function () {
  var hm = document.createElement("script");
  hm.src = `https://hm.baidu.com/hm.js?397b270e729ff58c59e6326e6d95707f`;
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

const app = createApp(App);

// 创建全局定时器对象
const globalTimer = {
  timerId: null,
  start(callback, interval) {
    this.stop(); // 先停止已有的定时器
    this.timerId = setInterval(callback, interval);
  },
  stop() {
    clearInterval(this.timerId);
    this.timerId = null;
  },
};
app.config.globalProperties.$globalTimer = globalTimer;

app.config.globalProperties.$utils = utils;
app.config.globalProperties.$enums = enums;
app.config.globalProperties.$consts = consts;
app.use(store).use(router);
app.mount("#app");
